import React from 'react';
import type { DiaryItem } from '../models/diary';

const MealItemEditForm: React.FC<{ item: DiaryItem; onChange: (field: string, value: any) => void }> = ({ item, onChange }) => (
  <>
    <label>Nombre
      <input value={item.name} onChange={e => onChange('name', e.target.value)} style={{ width: '100%', marginBottom: 10 }} />
    </label>
    <label>Día de la semana
      <select value={item.dayOfWeek} onChange={e => onChange('dayOfWeek', e.target.value)} style={{ width: '100%', marginBottom: 10 }}>
        <option value="Monday">Lunes</option>
        <option value="Tuesday">Martes</option>
        <option value="Wednesday">Miércoles</option>
        <option value="Thursday">Jueves</option>
        <option value="Friday">Viernes</option>
        <option value="Saturday">Sábado</option>
        <option value="Sunday">Domingo</option>
      </select>
    </label>
    <label>Momento del día
      <select value={item.timeOfDay} onChange={e => onChange('timeOfDay', e.target.value)} style={{ width: '100%', marginBottom: 10 }}>
        <option value="Morning">Mañana</option>
        <option value="Afternoon">Tarde</option>
        <option value="Evening">Noche</option>
        <option value="Other">Otro</option>
      </select>
    </label>
    <label>Orden
      <input type="number" value={item.order} onChange={e => onChange('order', parseInt(e.target.value))} style={{ width: '100%', marginBottom: 10 }} min="1" />
    </label>
    <label style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
      <input type="checkbox" checked={item.hidden || false} onChange={e => onChange('hidden', e.target.checked)} style={{ marginRight: 8 }} />
      Oculto
    </label>
  </>
);

export default MealItemEditForm; 